import React from 'react';

import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { IconButton } from '@mui/material';

import Button from 'pages/UserInfo/components/Button';

import useStyles from './styles';

interface Props {
    compact?: boolean;
    className?: string;
}

const FeedbackButton: React.FC<Props> = ({ compact, className }) => {
    const { classes, cx } = useStyles();

    return compact ? (
        <IconButton
            className={cx(classes.common, classes.icon, className)}
            disableRipple
            disableFocusRipple
            sx={{ visibility: 'hidden' }}
        >
            <ChatBubbleOutlineIcon />
        </IconButton>
    ) : (
        <Button
            fullWidth
            disableElevation
            disableRipple
            disableFocusRipple
            variant="outlined"
            className={cx(classes.common, classes.regular, className)}
            sx={{ visibility: 'hidden' }}
        >
            {'Feedback'}
        </Button>
    );
};

export default FeedbackButton;
